import React from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { useProjectStore } from "presentation/stores/use-project-store";
import { formatDateToPTLong } from "presentation/utils/formatDateToPT";
import { ProjectStatusHistory } from "domain/entities/project-status-history";

const ProjectStatusHistoryTab: React.FC = () => {
  const { project } = useProjectStore();

  const history: ProjectStatusHistory[] = project?.statusHistories || [];

  return (
    <div className="card">
      <DataTable
        value={history}
        emptyMessage="Nenhum histórico encontrado para este projeto."
        paginator
        rows={10}
        rowsPerPageOptions={[5, 10, 25]}
        className="p-datatable-sm"
        stripedRows
      >
        <Column field="oldStatus" header="Status Anterior" sortable />
        <Column field="newStatus" header="Novo Status" sortable />
        <Column
          field="justification"
          header="Justificativa"
          body={(rowData: ProjectStatusHistory) => (
            <div style={{ whiteSpace: "pre-wrap" }}>
              {rowData.justification || "-"}
            </div>
          )}
        />
        <Column
          field="createdAt"
          header="Data"
          sortable
          body={(rowData: ProjectStatusHistory) =>
            rowData.createdAt ? formatDateToPTLong(rowData.createdAt) : "-"
          }
        />
        <Column
          field="createdBy"
          header="Utilizador"
          sortable
          body={(rowData: ProjectStatusHistory) => rowData.createdBy || "-"}
        />
      </DataTable>
    </div>
  );
};

export default ProjectStatusHistoryTab;
